<template>
  <el-select
    v-if="!useVuetify"
    v-model="selectedId"
    @change="doChange"
    :placeholder="callPlaceholder"
    :size="size"
  >
    <el-option
      v-if="allowAll"
      :value="0"
      :label="
        getAppConfig?.callCenter?.useCallResult === true
          ? 'All Call Results'
          : 'All Call Types'
      "
    ></el-option>
    <el-option
      v-for="option in getCallResults"
      :value="returnTypeString ? String(option.id) : +option.id"
      :key="option.id"
      :label="option.label"
    >
      <!-- TODO add label color -->
    </el-option>
  </el-select>
  <v-select
    v-else
    v-model="selectedId"
    @update:model-value="doChange"
    :placeholder="callPlaceholder"
    :density="mazSize"
    :items="selectItems"
    rounded-size="sm"
    :block="true"
    autocomplete="off"
    listPosition="top"
    :disabled="disabled"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'callResultSelect',
  computed: {
    ...mapGetters('callResults', ['getCallResults']),
    selectItems() {
      const options = this.getCallResults.map((result) => {
        return {
          id: result.id,
          value: this.returnTypeString ? String(result.id) : result.id,
          title: result.label,
        };
      });

      if (this.allowAll) {
        options.unshift({
          value: 0,
          title:
            this.getAppConfig?.callCenter?.useCallResult === true
              ? 'All Call Results'
              : 'All Call Types',
        });
      }
      return options;
    },
    mazSize() {
      const sizeMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return sizeMap[this.size] || 'compact';
    },
  },
  emits: ['change'],
  props: {
    initialId: {
      type: Number,
      default: () => undefined,
    },
    size: {
      type: String,
      default: () => 'small',
    },
    placeholder: {
      type: String,
      required: false,
    },
    returnTypeString: {
      type: Boolean,
      default: () => false,
    },
    allowAll: {
      type: Boolean,
      default: () => false,
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedId: undefined,
      useCallResult: false,
      callPlaceholder: 'Select a Call Type',
    };
  },
  watch: {
    value(n) {
      this.selectedId = parseInt(n);
    },
    initialId(n) {
      if (n) {
        this.selectedId = parseInt(n);
      }
    },
  },
  async created() {
    if (this.placeholder != undefined) {
      this.callPlaceholder = this.placeholder;
    } else {
      // This will be removed in time, plan for it to be gone
      this.callPlaceholder =
        this.getAppConfig()?.callCenter?.useCallResult === true
          ? 'Select a Call Result'
          : 'Select a Call Type';
    }
    await this.fetchCallResults();
    if (this.initialId) {
      this.selectedId = parseInt(this.initialId);
    }
  },
  methods: {
    ...mapActions('callResults', ['fetchCallResults']),
    ...mapGetters('appConfig', ['getAppConfig']),
    doChange() {
      /*
      this.$emit(
        'input',
        this.getCallResults.find((cr) => cr.id == this.selectedId)
      );
      */
      this.$emit(
        'change',
        this.getCallResults.find((cr) => cr.id == this.selectedId)
      );
    },
  },
};
</script>
